export default "__VITE_PUBLIC_ASSET__d83bb44d__"